import React from "react";
import GestionServices from "./GestionServices";

// One responsive workspace keeps forms, details and permission checks shared.
export default function ResponsiveServices(props) {
  return <GestionServices {...props} />;
}
